// Basic translation strings
export const translations = {
    tr: {
        common: {
            tip: "İpucu",
            result: "Sonuç",
            calculate: "Hesapla",
            selectOperation: "İşlem Seçiniz",
            home: "Ana Sayfa",
            search: "Ara...",
            search_results: "Arama Sonuçları",
            no_results_found: "Sonuç bulunamadı",
            results: "Sonuç",
            title: "Hesaplama.Vip",
            toggleLight: "Gündüz moduna geç",
            toggleDark: "Gece moduna geç",
            loading: "Yükleniyor...",
            calculator: "Hesap Makinesi",
            calculators: "Hesaplayıcılar"
        },
        home: {
            heroTitle: "Hesaplama.Vip",
            heroSubtitle: "Modern hesaplama araçları koleksiyonu",
            searchPlaceholder: "Hesaplayıcı ara (örn. yüzde)",
            searchResults: "Arama Sonuçları",
            noResults: "için sonuç bulunamadı",
            tryDifferent: "Farklı bir arama terimi deneyin",
            calculator: "Hesap Makinesi",
            waterCalc: "Su Hesapla",
            popularCalculators: "Popüler Hesaplayıcılar",
            favorites: "Favorilerim",
            categories: "Kategoriler",
            features: "Özellikler",
            about: "Hakkımızda",
            contact: "İletişim",
            privacy: "Gizlilik Politikası",
            allCalculators: "Tüm Hesaplayıcılar",
            popularPercentage: "Popüler Yüzde Hesaplamaları",
            popularGold: "Sık Aranan Altın Değerleri",
            popularNumbers: "Sık Aranan Sayı Okunuşları",
            popularSqrt: "Popüler Karekök Hesaplamaları",
            popularDesc: "Kullanıcılar tarafından en çok merak edilen ve aranan hesaplamaları aşağıda bulabilirsiniz.",
            viewAll: "Tümünü Gör"
        },
        tools: {
            title: "Tüm Hesaplayıcılar",
            home: "Ana Sayfa",
            percentage: "Yüzde Hesaplama",
            pronunciation: "Sayı Okunuşu",
            gold: "Altın Hesaplama",
            goldCalculator: "Altın Hesaplama",
            currency: "Döviz Çevirici",
            sqrt: "Karekök Hesaplama",
            dollarTl: "Dolar TL Çeviri",
            euroTl: "Euro TL Çeviri",
            dollarEuro: "Dolar Euro Çevirici",
            gradeCalculator: "Ders Notu Hesaplama",
            priceIncrease: "Zam Hesaplama",
            bmi: "Vücut Kitle Endeksi",
            bmr: "Bazal Metabolizma Hızı",
            idealWeight: "İdeal Kilo Hesaplama",
            calorieNeed: "Günlük Kalori İhtiyacı",
            yasHesaplama: "Yaş Hesaplama",
            daysCalculator: "Kaç Gün Oldu",
            waterNeed: "Su İhtiyacı Hesaplama",
            calcApp: "Hesap Makinesi",
            weightUnitConverter: "Ağırlık Birimi Dönüştürücü",
            lengthUnitConverter: "Uzunluk Birimi Dönüştürücü",
            obpCalculator: "OBP Hesaplama",
            klimaBtu: "Klima BTU Hesaplama",
            // Missing tools added
            wordCount: "Kelime Sayısı Hesaplama",
            loremIpsum: "Lorem Ipsum Üretici",
            cryptoCalculator: "Kripto Kâr/Zarar Hesaplama",
            cryptoCurrencyConverter: "Kripto Para Çevirici",
            yoldaGecenZaman: "Yolda Geçen Zaman Hesaplama",
            dataUnitConverter: "Veri Birimi Dönüştürücü",
            energyUnitConverter: "Enerji Birimi Dönüştürücü",
            dailyRentalIncome: "Günlük Kira Getirisi",
            elektrikFaturasi: "Elektrik Faturası Hesaplama",
            dogalgazFaturasi: "Doğalgaz Faturası Hesaplama",
            jsonFormatter: "JSON Formatlayıcı",
            textCaseConverter: "Metin Dönüştürücü",
            urlEncodeDecoder: "URL Encode/Decode",
            base64EncodeDecode: "Base64 Encode/Decode",
            uuidGenerator: "UUID Oluşturucu",
            hashCalculator: "Hash Hesaplama",
            qrCodeGenerator: "QR Kod Oluşturucu",
            imageResizer: "Resim Boyutlandırma",
            textFormatter: "Metin Düzenleyici",
            passwordGenerator: "Şifre Oluşturucu",
            colorPicker: "Renk Seçici",
            timeZoneConverter: "Saat Dilimi Dönüştürücü",
            cssMinifier: "CSS Sıkıştırıcı",
            jsBeautifier: "JS Güzelleştirici",
            textToASCII: "Metin - ASCII Çevirici",
            imageCompressor: "Resim Sıkıştırıcı",
            imageFormatConverter: "Resim Formatı Dönüştürücü",
            faviconGenerator: "Favicon Oluşturucu",
            fuelConsumption: "Yakıt Tüketimi Hesaplama",
            animalSounds: "Hayvan Sesleri",
            liseMezuniyet: "Lise Mezuniyet Puanı",
            yumurtlamaDonemi: "Yumurtlama Dönemi",
            sutyenOlcüsü: "Sütyen Ölçüsü Hesaplama",
            tusPuan: "TUS Puan Hesaplama",
            tytPuan: "TYT Puan Hesaplama",
            desiCalculator: "Desi Hesaplama",
            metabolizmaYasi: "Metabolizma Yaşı Hesaplama",
            braSize: "Sütyen Ölçüsü Hesaplama",
            // New additions for missing keys
            inch: "İnç Hesaplama",
            mile: "Mil Hesaplama",
            macroNutrient: "Makro Besin Hesaplama",
            proteinNeed: "Protein İhtiyacı Hesaplama",
            carbNeed: "Karbonhidrat İhtiyacı Hesaplama",
            fatNeed: "Yağ İhtiyacı Hesaplama",
            goldenRatio: "Altın Oran Hesaplama",
            bodyFat: "Vücut Yağ Oranı Hesaplama",
            waistHipRatio: "Bel Kalça Oranı Hesaplama",
            babyHeight: "Bebek Boyu Hesaplama",
            babyWeight: "Bebek Kilosu Hesaplama",
            birthDate: "Doğum Tarihi Hesaplama",
            smokingCost: "Sigara Maliyeti Hesaplama",
            zekat: "Zekat Hesaplama",
            gpaCalculator: "GPA Hesaplama",
            factorial: "Faktöriyel Hesaplama",
            gcdlcm: "EBOB EKOK Hesaplama",
            combination: "Kombinasyon Hesaplama",
            permutation: "Permütasyon Hesaplama",
            area: "Alan Hesaplama",
            volume: "Hacim Hesaplama",
            perimeter: "Çevre Hesaplama",
            primeFactor: "Asal Çarpan Hesaplama",
            squareMeter: "Metrekare Hesaplama",
            baseConversion: "Taban Dönüşümü",
            power: "Üslü Sayı Hesaplama",
            ratio: "Oran Hesaplama",
            modular: "Modüler Aritmetik Hesaplama",
            random: "Rastgele Sayı Üretici",
            stdDev: "Standart Sapma Hesaplama",
            // Missing keys reported by user
            turkishCharCleaner: "Türkçe Karakter Düzeltici",
            dollarTlCalculator: "Dolar TL Hesaplama",
            tlDolarCalculator: "TL Dolar Hesaplama",
            euroDolarCalculator: "Euro Dolar Hesaplama",
            tlEuroCalculator: "TL Euro Hesaplama",
            euroTlCalculator: "Euro TL Hesaplama"
        },
        percentage: {
            calcTypes: {
                percentOfNumber: "A Sayısının %B'si Kaçtır?",
                valueIsWhatPercentOfNumber: "A Sayısı B Sayısının Yüzde Kaçıdır?",
                percentChange: "A'dan B'ye Yüzde Değişim Oranı",
                increaseByPercent: "A Sayısını %B Artır",
                decreaseByPercent: "A Sayısını %B Azalt"
            },
            valueA: "A Değeri",
            placeholderA: "A sayısını girin...",
            valueB: "B Değeri",
            placeholderB: "B sayısını girin...",
            hint: "Yapmak istediğiniz yüzde hesaplama türünü yukarıdan seçin. A ve B değerlerini girdikten sonra 'Hesapla' butonuna basın.",
            popularSearches: "Popüler Yüzde Hesaplamaları",
            popularSearchesDesc: "Kullanıcılar tarafından en çok aranan yüzde hesaplamaları.",
            goToCalc: "Yüzde Hesaplama Aracına Git"
        },
        gold: {
            title: "Altın Çevirici ve Dönüştürücü",
            amount: "Altın Miktarı",
            type: "Altın Türü",
            calculate: "Hesapla",
            result: "Hesaplanan Değer",
            history: "Hesaplama Geçmişi",
            table: "Altın Türleri Dönüşüm Tablosu",
            price: "Fiyat",
            gram: "Gram Altın",
            quarter: "Çeyrek Altın",
            half: "Yarım Altın",
            full: "Tam Altın",
            ata: "Ata Altın",
            resat: "Reşat Altın",
            hamit: "Hamit Altın",
            republic: "Cumhuriyet Altın",
            once: "Ons Altın",
            bracelet22: "22 Ayar Bilezik",
            bracelet18: "18 Ayar Bilezik",
            bracelet14: "14 Ayar Bilezik",
            bracelet24: "24 Ayar Bilezik",
            gremse: "Gremse Altın",
            ingot: "Külçe Altın",
            jewelry: "Ziynet Altın",
            entered: "Girilen",
            converted: "Sonuç",
            unit: "Birim",
            tlAmount: "TL Miktarı",
            goldToMoney: "Altın → Para",
            moneyToGold: "Para → Altın"
        },
        grade: {
            title: "Ders Notu Hesaplama",
            subtitle: "Ders Notunuzu Hesaplayın",
            description: "Öğrencilerin yazılı, sözlü, performans, proje gibi notlarının ortalaması, notların toplamının not sayısına bölünmesiyle hesaplanır. Boş bırakılan notlar ortalama hesaplamasına dahil edilmez. E-Okul sistemiyle %100 aynıdır.",
            exams: "Yazılı Sınavlar",
            projects: "Proje Görevleri",
            activities: "Ders Etkinliklerine Katılım",
            examLabel: "{n}. Yazılı Sınav",
            projectLabel: "{n}. Proje Görevi",
            activityLabel: "{n}. Ders Etkin. Katılım",
            placeholder: "Örn. 76,50",
            resultsTitle: "Hesaplama Sonuçları",
            examAvg: "Yazılı Sınav Ortalaması",
            termPoint: "Dersin Dönem Puanı",
            termGrade: "Dersin Dönem Notu",
            aboutTitle: "Ders Notu Hesaplama Hakkında Bilgi",
            aboutDesc: "Boş bırakılan not alanları hesaplamaya dahil edilmez. E-Okul sistemiyle %100 aynıdır.",
            accordionTitle: "Ders Notu Hesaplama Hakkında Daha Fazla Bilgi",
            moreInfoTitle: "Ders Notu Hesaplama Ne İşe Yarar ve Nasıl Kullanılır?",
            moreInfoDesc: "Ders notu hesaplama aracı, öğrencilerin yazılı sınavlar, proje görevleri ve ders etkinlikleri gibi farklı değerlendirme kriterlerinden aldıkları notların ortalamasını hesaplar. Tüm not türlerini girerek dönem puanınızı ve harf notunuzu öğrenebilirsiniz.",
            formulaTitle: "Ders Notu Hesaplama Formülü",
            formulaAverage: "Ortalama: (Tüm Notların Toplamı) ÷ (Not Sayısı)",
            formulaLetter: "Harf Notu: 85+ = 5, 70-84 = 4, 60-69 = 3, 50-59 = 2, 1-49 = 1",
            usageTitle: "Ders Notu Hesaplama Kullanım Alanları",
            faqTitle: "Sıkça Sorulan Sorular",
            faq1Q: "Boş bırakılan notlar nasıl değerlendirilir?",
            faq1A: "Boş bırakılan not alanları hesaplamaya dahil edilmez, sadece girilen notlar ortalamaya katılır.",
            faq2Q: "Harf notları nasıl belirlenir?",
            faq2A: "85 ve üzeri 5, 70-84 arası 4, 60-69 arası 3, 50-59 arası 2, 49 ve altı 1 harf notu alır."
        },
        currency: {
            title: "Dolar TL Hesaplama",
            euroTitle: "Euro TL Hesaplama",
            dollar: "Dolar",
            euro: "Euro",
            tl: "Türk Lirası",
            amount: "Miktar",
            result: "Hesaplanan Değer",
            currentRate: "Güncel Anlık Kur",
            operationType: "İŞLEM TÜRÜ",
            dollarToTl: "Dolar'dan TL'ye",
            tlToDollar: "TL'den Dolar'a",
            dollarToEuro: "Dolar'dan Euro'ya",
            euroToDollar: "Euro'dan Dolar'a",
            tlToEuro: "TL'den Euro'ya",
            euroToTl: "Euro'dan TL'ye",
            updateRate: "Kuru Güncelle",
            detailedInfo: "Detaylı Bilgi"
        },
        seo: {
            titleSuffix: " - Hesaplama.Vip",
            descriptionPrefix: "",
        },
        categories: {
            math: "Matematik",
            finance: "Finans",
            islamic: "İslami Hesaplamalar",
            geometry: "Geometri",
            measurement: "Ölçüm",
            time: "Zaman",
            education: "Eğitim",
            health: "Sağlık",
            tools: "Yardımcı Araçlar",
            homeAppliances: "Ev ve Yaşam",
            automotive: "Otomotiv",
            income: "Kazanç Tahminleri"
        },
        sqrt: {
            title: "Karekök Hesaplama",
            subtitle: "Sayısal Özellikler ve Detaylar",
            perfectSquare: "tam kare bir sayıdır",
            notPerfectSquare: "tam kare bir sayı değildir",
            rational: "rasyonel bir",
            irrational: "irrasyonel bir",
            range: "{lower} ile {upper} arasındadır",
            nearest: "en yakın tamsayı",
            newCalculation: "Yeni Hesaplama",
            popularSearches: "Popüler Karekök Hesaplamaları"
        },
        pronunciation: {
            title: "Sayı Okunuşu Hesaplama",
            enterNumber: "Sayıyı Giriniz",
            result: "Sayının Okunuşu",
            copy: "Kopyala",
            copied: "Kopyalandı!",
            differentLanguages: "Farklı Dillerde Okunuşu",
            tr: "Türkçe",
            en: "İngilizce",
            nl: "Hollandaca",
            de: "Almanca",
            fr: "Fransızca",
            it: "İtalyanca"
        }
    },
    nl: {
        common: {
            tip: "Tip",
            result: "Resultaat",
            calculate: "Berekenen",
            selectOperation: "Selecteer Operatie",
            home: "Startpagina",
            search: "Zoeken...",
            search_results: "Zoekresultaten",
            no_results_found: "Geen resultaten gevonden",
            results: "Resultaat",
            title: "Hesaplama.Vip",
            toggleLight: "Lichte Modus",
            toggleDark: "Donkere Modus",
            loading: "Laden...",
            calculator: "Rekenmachine",
            calculators: "Rekenmachines"
        },
        home: {
            heroTitle: "Hesaplama.Vip",
            heroSubtitle: "Verzameling van moderne rekenmachines voor al uw dagelijkse berekeningen. Percentage, goud, financiën en wiskunde op één plek.",
            searchPlaceholder: "Zoek rekenmachine (bijv. percentage)",
            searchResults: "Zoekresultaten",
            noResults: "geen resultaten gevonden voor",
            tryDifferent: "Probeer een andere zoekterm",
            calculator: "Rekenmachine",
            waterCalc: "Water Berekenen",
            popularCalculators: "Populaire Rekenmachines",
            favorites: "Favorieten",
            categories: "Categorieën",
            features: "Kenmerken",
            about: "Over ons",
            contact: "Contact",
            privacy: "Privacybeleid",
            allCalculators: "Alle Rekenmachines",
            popularPercentage: "Populaire Percentage Zoekopdrachten",
            popularGold: "Veelgezochte Goudwaarden",
            popularNumbers: "Populaire Getal Schrijfwijzen",
            popularSqrt: "Populaire Wortel Zoekopdrachten",
            popularDesc: "Vind hieronder de meest gezochte en handige berekeningen door onze gebruikers.",
            viewAll: "Bekijk Alles"
        },
        tools: {
            title: "Alle Rekenmachines",
            home: "Startpagina",
            percentage: "Percentage Berekenen",
            pronunciation: "Getal Uitschrijven", // Writing out numbers
            gold: "Goudprijs Berekenen",
            goldCalculator: "Goudprijs Berekenen",
            currency: "Valuta Omrekenen",
            sqrt: "Wortel Berekenen",
            dollarTl: "Dollar naar Turkse Lira",
            euroTl: "Euro naar Turkse Lira",
            dollarEuro: "Dollar naar Euro",
            bmi: "BMI Berekenen",
            bmr: "BMR Berekenen",
            idealWeight: "Ideaal Gewicht Berekenen",
            calorieNeed: "Caloriebehoefte Berekenen",
            yasHesaplama: "Leeftijd Berekenen",
            daysCalculator: "Dagen Teller",
            waterNeed: "Waterbehoefte Berekenen",
            calcApp: "Rekenmachine",
            weightUnitConverter: "Gewicht Omrekenen",
            lengthUnitConverter: "Lengte Omrekenen",
            obpCalculator: "OBP Berekenen (Turkije)",
            klimaBtu: "Airco BTU Berekenen",
            // Missing tools added
            wordCount: "Woorden Tellen",
            loremIpsum: "Lorem Ipsum Generator",
            cryptoCalculator: "Crypto Winst/Verlies",
            cryptoCurrencyConverter: "Crypto Valuta Converter",
            yoldaGecenZaman: "Reistijd Berekenen",
            dataUnitConverter: "Data Eenheden Omrekenen",
            energyUnitConverter: "Energie Eenheden Omrekenen",
            dailyRentalIncome: "Dagelijkse Huurinkomsten",
            elektrikFaturasi: "Elektriciteitsrekening",
            dogalgazFaturasi: "Gasrekening",
            jsonFormatter: "JSON Formatter",
            textCaseConverter: "Tekst Vormgever",
            urlEncodeDecoder: "URL Encode/Decode",
            base64EncodeDecode: "Base64 Encode/Decode",
            uuidGenerator: "UUID Generator",
            hashCalculator: "Hash Calculator",
            qrCodeGenerator: "QR Code Generator",
            imageResizer: "Afbeelding Formaat Wijzigen",
            textFormatter: "Tekst Formatter",
            passwordGenerator: "Wachtwoord Generator",
            colorPicker: "Kleurenkiezer",
            timeZoneConverter: "Tijdzone Converter",
            cssMinifier: "CSS Minifier",
            jsBeautifier: "JS Beautifier",
            textToASCII: "Tekst naar ASCII",
            imageCompressor: "Afbeelding Comprimeren",
            imageFormatConverter: "Afbeelding Converteren",
            faviconGenerator: "Favicon Generator",
            fuelConsumption: "Brandstofverbruik",
            animalSounds: "Dierengeluiden",
            liseMezuniyet: "Middelbare School Score",
            yumurtlamaDonemi: "Ovulatie Berekenen",
            sutyenOlcüsü: "Bh Maat Berekenen",
            tusPuan: "TUS Score",
            tytPuan: "TYT Score",
            desiCalculator: "Desi Berekenen",
            metabolizmaYasi: "Metree Leeftijd Berekenen", // Metabolic Age
            braSize: "Bh Maat Berekenen",
            // New additions to fix missing keys
            inch: "Inch naar CM",
            mile: "Mijl naar KM",
            macroNutrient: "Macrovoedingsstoffen",
            proteinNeed: "Eiwitbehoefte",
            carbNeed: "Koolhydraatbehoefte",
            fatNeed: "Vetbehoefte",
            goldenRatio: "Gulden Snede",
            bodyFat: "Vetpercentage",
            waistHipRatio: "Taille-Heup Ratio",
            babyHeight: "Baby Lengte",
            babyWeight: "Baby Gewicht",
            birthDate: "Geboortedatum Berekenen",
            smokingCost: "Kosten Roken",
            zekat: "Zakaat Berekenen",
            gradeCalculator: "Cijfer Berekenen",
            gpaCalculator: "GPA Berekenen",
            priceIncrease: "Prijsverhoging Berekenen",
            factorial: "Faculteit",
            gcdlcm: "GGD en KGV",
            combination: "Combinatie",
            permutation: "Permutatie",
            area: "Oppervlakte",
            volume: "Volume",
            perimeter: "Omtrek",
            primeFactor: "Priemfactoren",
            squareMeter: "Vierkante Meter",
            baseConversion: "Base Conversie",
            power: "Machtsverheffen",
            ratio: "Ratio",
            modular: "Modulair Rekenen",
            random: "Willekeurig Getal",
            stdDev: "Standaardafwijking",
            // Missing keys
            turkishCharCleaner: "Turkse Karakter Corrector",
            dollarTlCalculator: "Dollar TL Calculator",
            tlDolarCalculator: "TL Dollar Calculator",
            euroDolarCalculator: "Euro Dollar Calculator",
            tlEuroCalculator: "TL Euro Calculator",
            euroTlCalculator: "Euro TL Calculator"
        },
        percentage: {
            calcTypes: {
                percentOfNumber: "Hoeveel is B% van A?",
                valueIsWhatPercentOfNumber: "Hoeveel procent is A van B?",
                percentChange: "Procentuele Verandering van A naar B",
                increaseByPercent: "Verhoog A met B%",
                decreaseByPercent: "Verlaag A met B%"
            },
            valueA: "Waarde A",
            placeholderA: "Voer getal A in...",
            valueB: "Waarde B",
            placeholderB: "Voer getal B in...",
            hint: "Selecteer een berekeningstype hierboven. Voer de waarden voor A en B in en klik op 'Berekenen'.",
            popularSearches: "Populaire Percentage Zoekopdrachten",
            popularSearchesDesc: "De meest gezochte percentage berekeningen door gebruikers.",
            goToCalc: "Ga naar de Percentage Calculator"
        },
        gold: {
            title: "Goud Converter en Rekenmachine",
            amount: "Hoeveelheid Goud",
            type: "Goud Type",
            calculate: "Berekenen",
            result: "Berekende Waarde",
            history: "Berekeningsgeschiedenis",
            table: "Goud Soorten Conversietabel",
            price: "Prijs",
            gram: "Gram Goud",
            quarter: "Kwart Goud (Çeyrek)",
            half: "Half Goud (Yarım)",
            full: "Vol Goud (Tam)",
            ata: "Ata Goud",
            resat: "Reşat Goud",
            hamit: "Hamit Goud",
            republic: "Republiek Goud",
            once: "Ounce",
            bracelet22: "22 Karaat Armband",
            bracelet18: "18 Karaat Armband",
            bracelet14: "14 Karaat Armband",
            bracelet24: "24 Karaat Armband",
            gremse: "Gremse Goud",
            ingot: "Goudstaaf",
            jewelry: "Sieraden Goud",
            entered: "Ingevoerd",
            converted: "Resultaat",
            unit: "Eenheid",
            tlAmount: "TL Bedrag",
            goldToMoney: "Goud → Geld",
            moneyToGold: "Geld → Goud"
        },
        grade: {
            title: "Cijfer Berekenen",
            subtitle: "Bereken je rapportcijfer",
            description: "Het gemiddelde van de cijfers van studenten voor schriftelijke, mondelinge, prestatie- en projecttaken wordt berekend door het totaal van de cijfers te delen door het aantal cijfers. Lege cijfers worden niet meegenomen in de berekening.",
            exams: "Schriftelijke Examens",
            projects: "Project Opdrachten",
            activities: "Deelname aan Activiteiten",
            examLabel: "{n}e Examen",
            projectLabel: "{n}e Project",
            activityLabel: "{n}e Activiteit",
            placeholder: "Bijv. 7,5",
            resultsTitle: "Berekeningsresultaten",
            examAvg: "Gemiddelde Examencijfer",
            termPoint: "Eindcijfer (Punten)",
            termGrade: "Eindcijfer (Rapport)",
            aboutTitle: "Informatie over Cijferberekening",
            aboutDesc: "Lege velden worden niet meegenomen in de berekening.",
            accordionTitle: "Meer informatie over Cijferberekening",
            moreInfoTitle: "Waar is de cijfercalculator voor en hoe gebruik je deze?",
            moreInfoDesc: "De cijfercalculator berekent het gemiddelde van verschillende evaluatiecriteria zoals schriftelijke examens, projecten en activiteiten.",
            formulaTitle: "Formule voor Cijferberekening",
            formulaAverage: "Gemiddelde: (Totaal van alle cijfers) ÷ (Aantal cijfers)",
            formulaLetter: "Cijferschaal (Turkije): 85+ = 5, 70-84 = 4, 60-69 = 3, 50-59 = 2, 1-49 = 1",
            usageTitle: "Toepassingen van Cijferberekening",
            faqTitle: "Veelgestelde Vragen",
            faq1Q: "Hoe worden lege velden behandeld?",
            faq1A: "Lege velden worden niet meegeteld in het gemiddelde.",
            faq2Q: "Hoe worden de cijfers bepaald?",
            faq2A: "Dit systeem is gebaseerd op het Turkse onderwijssysteem (e-Okul)."
        },
        currency: {
            title: "Dolar TL Berekenen",
            euroTitle: "Euro TL Berekenen",
            dollar: "Dollar",
            euro: "Euro",
            tl: "Turkse Lira (TL)",
            amount: "Bedrag",
            result: "Berekende Waarde",
            currentRate: "Actuele Koers",
            operationType: "TRANSACTIE TYPE",
            dollarToTl: "Dollar naar TL",
            tlToDollar: "TL naar Dollar",
            dollarToEuro: "Dollar naar Euro",
            euroToDollar: "Euro naar Dollar",
            tlToEuro: "TL naar Euro",
            euroToTl: "Euro naar TL",
            updateRate: "Koers Bijwerken",
            detailedInfo: "Gedetailleerde Informatie"
        },
        seo: {
            titleSuffix: " - Hesaplama.vip",
            descriptionPrefix: "",
        },
        categories: {
            math: "Wiskunde",
            finance: "Financiën",
            islamic: "Islamitische Berekeningen",
            geometry: "Meetkunde",
            measurement: "Meting",
            time: "Tijd",
            education: "Onderwijs",
            health: "Gezondheid",
            tools: "Hulpmiddelen",
            homeAppliances: "Huis & Wonen",
            automotive: "Automotive",
            income: "Inkomstenvoorspellingen"
        },
        sqrt: {
            title: "Wortel Berekenen",
            subtitle: "Numerieke Kenmerken en Details",
            perfectSquare: "is een volkomen kwadraat",
            notPerfectSquare: "is geen volkomen kwadraat",
            rational: "rationaal",
            irrational: "irrationaal",
            range: "ligt tussen {lower} en {upper}",
            nearest: "dichtstbijzijnde",
            newCalculation: "Nieuwe Berekening",
            popularSearches: "Populaire Wortel Zoekopdrachten"
        },
        pronunciation: {
            title: "Getal Schrijven",
            enterNumber: "Voer het getal in",
            result: "Schrijfwijze",
            copy: "Kopieren",
            copied: "Gekopieerd!",
            differentLanguages: "In andere talen",
            tr: "Turks",
            en: "Engels",
            nl: "Nederlands",
            de: "Duits",
            fr: "Frans",
            it: "Italiaans"
        }
    }
};

export type Language = 'tr' | 'nl';
